"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var PostsPagination = function (_a) {
    var onPageChange = _a.onPageChange, totalPages = _a.totalPages, active = _a.active;
    if (totalPages <= 1) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    else {
        return (react_1.default.createElement(semantic_ui_react_1.Pagination, { id: "pagination", activePage: active, ellipsisItem: {
                content: react_1.default.createElement(semantic_ui_react_1.Icon, { name: "ellipsis horizontal" }),
                icon: true,
            }, siblingRange: 1, boundaryRange: 0, firstItem: null, lastItem: null, totalPages: totalPages, secondary: true, onPageChange: function (e, _a) {
                var _b = _a.activePage, activePage = _b === void 0 ? 1 : _b, _c = _a.totalPages, totalPages = _c === void 0 ? 1 : _c;
                onPageChange(+activePage);
            } }));
    }
};
exports.default = PostsPagination;
